module.exports = __webpack_public_path__ + "static/media/fullLogo.7aab457f.svg";